import { render, staticRenderFns } from "./group-selfCreated.vue?vue&type=template&id=0e264380"
import script from "./group-selfCreated.vue?vue&type=script&lang=js"
export * from "./group-selfCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports